<fleet-dialog-layout
  [title]="'Change Username / email'"
  [iconColour]="'primary'"
  [icon]="'warning'"
  [showCancel]="!hasUsernameChanged"
  >
  <div slot="main">
    @if (hasUsernameChanged) {
      <div class="text-lg">
        {{
        'Your username/email has changed to ' +
        usernameControl.value +
        '. Whenever you log in again this will be your new username'
        }}
      </div>
    } @else {
      @if (verification) {
        <ng-container slot="main">
          <div>
            We've sent a code {{ usernameControl.value }}
            Please check your email and enter the code below
          </div>
          <div class="flex w-full m-auto p-8 justify-center">
            <mat-form-field class="w-full w-40">
              <input
                matInput
                placeholder="Enter code"
                [formControl]="codeControl"
                />
            </mat-form-field>
          </div>
        </ng-container>
      } @else {
        <mat-form-field class="w-full">
          <input
            matInput
            placeholder="New Email"
            [formControl]="usernameControl"
            />
        </mat-form-field>
      }
    }

  </div>
  @for (alert of issues | alertsFromIssues; track alert) {
    <fuse-alert
      slot="error"
      class=""
      [appearance]="'outline'"
      [showIcon]="true"
      [type]="alert.type"
      [@shake]="alert.type === 'error'"
      >
      {{ alert.message }}
    </fuse-alert>
  }

  <ng-container slot="action">
    @if (!verification && !hasUsernameChanged) {
      <button
        [disabled]="!usernameControl.valid"
        mat-flat-button
        class="bg-primary-600 text-white disabled:bg-gray-200"
        (click)="begin()"
        >
        NEXT
      </button>
    }
    @if (verification && !hasUsernameChanged) {
      <fleet-progress-button
        [state]="{ buttonLabel: 'Verify', loading: loading }"
        [loading]="loading"
        (onClick)="verify()"
      ></fleet-progress-button>
    }
    @if (hasUsernameChanged) {
      <button
        class="bg-primary-600 text-white disabled:bg-gray-200"
        mat-flat-button
        [matDialogClose]
        >
        OK
      </button>
    }
  </ng-container>
</fleet-dialog-layout>
